// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"48d5f8ae","46":"af3bbe7a","79":"eeff39e1","238":"b1c563ee","453":"1826ebbf","637":"9eebbec9","655":"59d2c227","727":"8e456c8b","809":"373214b9","853":"fc292853"}[chunkId] + ".chunk.js";
};